export default __webpack_public_path__ + "static/media/primary-actor-character-face-id.d7169162.png";